import { styled } from '@mui/material';

import { popoverContentHeaderClasses } from './theme';

import type { PopoverContentHeaderProps } from './types';

const PopoverContentHeader = (props: PopoverContentHeaderProps) => {
  const { title, icon } = props;

  if (!title && !icon) return null;

  return (
    <PopoverContentHeaderRoot>
      {title && <PopoverContentHeaderTitle>{title}</PopoverContentHeaderTitle>}
      {icon && <PopoverContentHeaderIcon>{icon}</PopoverContentHeaderIcon>}
    </PopoverContentHeaderRoot>
  );
};

const PopoverContentHeaderRoot = styled('div', {
  target: popoverContentHeaderClasses.root,
})`
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: space-between;
`;

const PopoverContentHeaderTitle = styled('div', {
  target: popoverContentHeaderClasses.title,
})`
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: #131619;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const PopoverContentHeaderIcon = styled('div', {
  target: popoverContentHeaderClasses.icon,
})`
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin-left: 4px;
`;

export default PopoverContentHeader;
